import { useSignal } from "@preact/signals-react"
import { postSubmit } from "@ui-seeker/utils"

import { WEBBACK_V2_API } from "@constants"
import { useToast, useUserApp } from "@hooks"
import {marketAnalyzerReportFormIsOpen, marketAnalyzerSubmittedFilters} from "../@signals";


export default function useMarketAnalyzerReportForm(dataRow={}) {
    const { showToast } = useToast()
    const { userEmail, userCustomer } = useUserApp()

    const nameReport = useSignal('')
    const frequency = useSignal(null)
    const emailsReport = useSignal([userEmail])

    const resetFormData = () => {
        nameReport.value = ''
        frequency.value = null
        emailsReport.value = [userEmail]
    }

    const handleOpenForm = () => {
        marketAnalyzerReportFormIsOpen.value = true
    }

    const handleSendToBack = () => {
        let apiUrl =`${WEBBACK_V2_API}/reports/create`

        if (frequency.value === 'now') {
            apiUrl = `${WEBBACK_V2_API}/reports/execute-now`
        }

        const payload = {
            nameReport: nameReport.value,
            frequency: frequency.value,
            emailsReport: emailsReport.value.join(","),
            reportType: 'marketAnalyzer',
            filters: {
                country: marketAnalyzerSubmittedFilters.value.country, retailer: marketAnalyzerSubmittedFilters.value.retailer,
                brand: marketAnalyzerSubmittedFilters.value.brand, skuGroup: marketAnalyzerSubmittedFilters.value.skuGroup,
                sku: marketAnalyzerSubmittedFilters.value.sku, id_customer: userCustomer
            }
        }

        showToast.promise(postSubmit(apiUrl, payload), {
            error: 'Error: Please try again later.',
            success: `Report successfully created.`,
        })
    }

    return {
        handleOpenForm,
        handleSendToBack,
        resetFormData,
        nameReport: nameReport,
        frequency: frequency,
        emailsReport: emailsReport
    }
}